module.exports = __webpack_public_path__ + "static/media/LOADER_12.8cab031a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loading_page/LOADER_12.png
// module id = 320
// module chunks = 0